import { useEffect } from "react";
// componentes
import MapaUbicacionServicio from "../../../../componentesEspeciales/crearEditar/mapa";
import ModalUsarIA from "../../../../componentesEspeciales/crearEditar/modalUsarIA";
// funciones
import { solicitarYGuardarUbicacion } from "../../../../funcionesDatos/solicitarUbicacion";

function Paso2({
  formServicio,
  setFormServicio,
  cateConfig,
  tipoServicio,
  tipoDesplazamiento,
  categoriaSeleccionada,
  setCategoriaSeleccionada,
  subCategoriaSeleccionada,
  setSubCategoriaSeleccionada,
  subcategoriasDisponibles,
  paisSeleccionado,
  zonaSeleccionada,
  setZonaSeleccionada,
  zonas,
  ciudades,
  setCiudades,
  ciudadSeleccionada,
  setCiudadSeleccionada,
  subZonaTipo,
  setSubZonaTipo,
  subZonasPorCiudad,
  setSubZonasPorCiudad,
  direccionTexto,
  setDireccionTexto,
  referencia,
  setReferencia,
  latitud,
  longitud,
  setLatitud,
  setLongitud,
  setPrecisionUbicacion,
  divisaServicio,
  guardarProgreso,
  setPasoActual,
  BotonesaPasos,
  ubicacionUsuario,
  usuarioActual,
  setUbicacionUsuario,
  idServicio,
  onSuccessIA,
}) {
  const subZonasDisponibles = Array.isArray(subZonasPorCiudad?.[ciudadSeleccionada]) ? subZonasPorCiudad[ciudadSeleccionada] : [];
  const mostrarSubzonas = Boolean(ciudadSeleccionada) && subZonasDisponibles.length > 0;
  const labelSubZonaTipo = String(subZonaTipo || "Subzona").replace(/_/g, " ");

  const permitirMultiplesSubzonas = tipoDesplazamiento === "Domicilio" || tipoDesplazamiento === "Ambos";
  const subzonasSeleccionadas = Array.isArray(formServicio?.subzonas) ? formServicio.subzonas : [];
  const coberturaCompletaCiudad = Boolean(formServicio?.coberturaCompletaCiudad);

  //console.log("subzonas por ciudad: ", subZonasPorCiudad);
  //console.log("subzonasSeleccionadas: ", subzonasSeleccionadas);
  //console.log("formservicio desde paso2: ", formServicio);

  function toggleSubzona(valor) {
    const actual = Array.isArray(formServicio?.subzonas) ? formServicio.subzonas : [];

    if (valor === "__toda_la_ciudad__") {
      const siguienteEstado = !coberturaCompletaCiudad;
      setFormServicio((prev) => ({
        ...prev,
        coberturaCompletaCiudad: siguienteEstado,
        subzonas: siguienteEstado ? [...subZonasDisponibles] : [],
        subzona: "",
      }));
      return;
    }

    const existe = actual.includes(valor);
    const siguiente = existe
      ? actual.filter((item) => item !== valor)
      : [...actual, valor];

    setFormServicio((prev) => ({
      ...prev,
      coberturaCompletaCiudad: false,
      subzonas: siguiente,
      subzona: "",
    }));
  }

  useEffect(() => {
    if (
      tipoServicio === "Presencial" &&
      tipoDesplazamiento === "EnLocal" &&
      (latitud == null || longitud == null) &&
      ubicacionUsuario?.permiso === "aprobado" &&
      ubicacionUsuario?.latitud != null &&
      ubicacionUsuario?.longitud != null
    ) {
      setLatitud(ubicacionUsuario.latitud);
      setLongitud(ubicacionUsuario.longitud);
      setPrecisionUbicacion("exacta");
    }
  }, [
    tipoServicio,
    tipoDesplazamiento,
    latitud,
    longitud,
    ubicacionUsuario,
    setLatitud,
    setLongitud,
    setPrecisionUbicacion,
  ]);

  async function obtenerUbicacionActual() {
    try {
      const ubicacionActualizada = await solicitarYGuardarUbicacion(usuarioActual);

      if (
        ubicacionActualizada?.permiso === "aprobado" &&
        ubicacionActualizada?.latitud != null &&
        ubicacionActualizada?.longitud != null
      ) {
        if (typeof setUbicacionUsuario === "function") {
          setUbicacionUsuario(ubicacionActualizada);
        }

        setLatitud(ubicacionActualizada.latitud);
        setLongitud(ubicacionActualizada.longitud);
        setPrecisionUbicacion("exacta");
      }
    } catch (err) {
      console.log("error obteniendo ubicacion actual en paso 2:", err);
    }
  }

  return (
    <div className="card border-0 shadow-sm mb-4">
      <div className="card-body">
        {/* PASO 2 */}
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div>
            <h5 className="mb-1">Paso 2</h5>
            <small className="text-muted">Nombre, descripción, categoría y ubicación</small>
          </div>
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <span className="badge rounded-pill border" style={{ backgroundColor: "var(--color-bg-accent-subtle)", color: "var(--color-text-primary)", borderColor: "var(--azul-cielo)", fontWeight: 600 }}>
              {divisaServicio === "USD" ? "🇺🇸 USD" : "🇨🇴 COP"}
            </span>
            <span className="badge text-bg-primary">2 / 5</span>
          </div>
        </div>
        <div className="mt-3">
          <ModalUsarIA idServicio={idServicio} usoIA={formServicio?.usoIA || 0} onSuccess={onSuccessIA} />
        </div>



        <form className="mt-3" onSubmit={(e) => e.preventDefault()}>
          <h3 className="mt-2">Descripción</h3>


          {/* TITULO */}
          <div className="form-floating mb-3">
            <input
              value={formServicio.titulo}
              name="titulo"
              type="text"
              className="form-control"
              placeholder="Título"
              maxLength={60}
              onChange={(e) => setFormServicio((prev) => ({ ...prev, titulo: e.target.value }))}
            />
            <label htmlFor="floatingTextarea">Título del servicio</label>
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
              <span className="textoBajoInput mb-0"> Ingresa un título claro y atractivo para tu servicio. Por ejemplo: “Pasearé a tus mascotas” o “Instalaré tu TV”. Mínimo 5 caracteres.</span>
              <span className="textoBajoInput mb-0 text-muted">Máximo 60 caracteres.</span>
            </div>
          </div>




          {/* DESCRIPCIÓN */}
          <div className="form-floating mb-3">
            <textarea
              id="floatingTextarea2"
              style={{ height: "200px" }}
              value={formServicio.descripcion}
              name="descripcion"
              className="form-control"
              placeholder="Descripción"
              maxLength={900}
              onChange={(e) => setFormServicio((prev) => ({ ...prev, descripcion: e.target.value }))}
            />
            <label htmlFor="floatingTextarea">Descripción del servicio.</label>
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
              <span className="textoBajoInput mb-0">Ingresa una descripción completa de tu servicio. Mínimo 15 caracteres.</span>
              <span className="textoBajoInput mb-0 text-muted">Máximo 900 caracteres.</span>
            </div>
          </div>




          {/* CATEGORIA */}
          <div className="form-floating mb-3">
            <select
              className="form-select"
              id="floatingSelectCategoria"
              value={categoriaSeleccionada}
              onChange={(e) => setCategoriaSeleccionada(e.target.value)}
            >
              <option value="">Seleccione una categoría</option>
              {Array.isArray(cateConfig) &&
              cateConfig.map((c, index) => (
                <option key={c?.categoria || index} value={c?.categoria || ""}>
                  {c?.categoria}
                </option>
              ))}
            </select>
            <label htmlFor="floatingSelectCategoria">Categoría</label>
          </div>




          {/* SUBCATEGORIA */}
          {categoriaSeleccionada && (
            <div className="form-floating mb-3">
              <select
                className="form-select"
                id="floatingSelectSubcategoria"
                value={subCategoriaSeleccionada}
                onChange={(e) => setSubCategoriaSeleccionada(e.target.value)}
                disabled={subcategoriasDisponibles.length === 0}
              >
                <option value="">Seleccione una subcategoría</option>
                {subcategoriasDisponibles.map((subcat, index) => (
                  <option key={subcat + index} value={subcat}>
                    {subcat}
                  </option>
                ))}
              </select>
              <label htmlFor="floatingSelectSubcategoria">Subcategoría</label>
            </div>
          )}




          {/* UBICACIÓN */}
          {tipoServicio !== "Digital" && (
            <>
              {/* TEXTO INICIAL */}
              <h3 className="mt-5">Ubicación</h3>
              {tipoDesplazamiento === "EnLocal" 
              ? <p> Selecciona la ubicación exacta de tu local o negocio donde prestarás tu servicio. </p>
              : <p> Selecciona la ciudad o subzona de cobertura que tiene tu servicio.</p>
              }


              <div className="row g-3">
                {/* País */}
                <div className={`col-12 ${mostrarSubzonas ? "col-md-3" : "col-md-4"}`}>
                  <div className="form-floating">
                    <input type="text" className="form-control" value={paisSeleccionado} readOnly />
                    <label>País</label>
                    <p className="textoBajoInput">Por defecto: Colombia (más adelante podrás cambiar el país).</p>
                  </div>
                </div>

                {/* Zona */}
                <div className={`col-12 ${mostrarSubzonas ? "col-md-3" : "col-md-3"}`}>
                  <div className="form-floating">
                    <select
                      className="form-select"
                      value={zonaSeleccionada}
                      onChange={(e) => {
                        const z = e.target.value;
                        setZonaSeleccionada(z);

                        const zonaEncontrada = Array.isArray(zonas)
                          ? zonas.find((item) => item?.departamento === z)
                          : null;

                        setCiudades(Array.isArray(zonaEncontrada?.ciudades) ? zonaEncontrada.ciudades : []);
                        setSubZonaTipo(zonaEncontrada?.subzonasTipo || "");
                        setSubZonasPorCiudad(zonaEncontrada?.subzonasPorCiudad || {});
                        setCiudadSeleccionada("");
                        setFormServicio((prev) => ({ ...prev, coberturaCompletaCiudad: false, subzona: "", subzonas: [] }));
                      }}
                    >
                      <option value="">Seleccione una zona</option>
                      {Array.isArray(zonas) && zonas.map((z, idx) => (
                        <option key={z?.departamento || idx} value={z?.departamento || ""}>
                          {z?.departamento || "Zona"}
                        </option>
                      ))}
                    </select>
                    <label>Zona</label>
                    <p className="textoBajoInput"> {tipoDesplazamiento === "EnLocal" ? "Selecciona la zona donde está tu local." : "Selecciona la zona donde prestarás este servicio."} </p>
                  </div>
                </div>




                {/* Ciudad */}
                <div className={`col-12 ${mostrarSubzonas ? "col-md-3" : "col-md-5"}`}>
                  <div className="form-floating">
                    <select
                      className="form-select"
                      value={ciudadSeleccionada}
                      onChange={(e) => {
                        setCiudadSeleccionada(e.target.value);
                        setFormServicio((prev) => ({ ...prev, coberturaCompletaCiudad: false, subzona: "", subzonas: [] }));
                      }}
                      disabled={!zonaSeleccionada}
                    >
                      <option value="">Seleccione una ciudad</option>
                      {Array.isArray(ciudades) && ciudades.map((c, idx) => (
                        <option key={idx} value={c}>{c}</option>
                      ))}
                    </select>
                    <label>Ciudad</label>
                    <p className="textoBajoInput"> {tipoDesplazamiento === "EnLocal" ? "Selecciona la ciudad donde está tu local." : "Selecciona la ciudad donde se prestará el servicio."} </p>
                  </div>
                </div>

                {/* SUBZONA */}
                {mostrarSubzonas ? (
                  <div className="col-12 col-md-3">
                    {/* MULTIPLES ZONAS PARA COBERTURA DOMICIOLO */}
                    {permitirMultiplesSubzonas ? 
                    <div className="border rounded-4 p-3 h-100" style={{ background: "var(--color-bg-surface)" }}>
                      <label className="form-label fw-semibold mb-2 d-block">{labelSubZonaTipo}</label>

                      <div className="form-check mb-2">
                        {/* INPUT TODA LA CIUDAD */}
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`subzona-toda-${ciudadSeleccionada}`}
                          checked={coberturaCompletaCiudad}
                          onChange={() => toggleSubzona("__toda_la_ciudad__")}
                        />
                        <label className="form-check-label" htmlFor={`subzona-toda-${ciudadSeleccionada}`}>
                          {`Todo ${ciudadSeleccionada}`}
                        </label>
                      </div>

                      {/* CHECKBOX SUBZONAS */}
                      <div className="border-top pt-2 mt-2" style={{ maxHeight: 210, overflowY: "auto" }}>
                        {subZonasDisponibles.map((subzona, idx) => {
                          const id = `subzona-${idx}-${subzona}`;
                          const deshabilitada = coberturaCompletaCiudad;
                          return (
                            <div className="form-check mb-2" key={subzona + idx}>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={id}
                                checked={subzonasSeleccionadas.includes(subzona)}
                                disabled={deshabilitada}
                                onChange={() => toggleSubzona(subzona)}
                              />
                              <label className="form-check-label" htmlFor={id}>
                                {subzona}
                              </label>
                            </div>
                          );
                        })}
                      </div>

                      <p className="textoBajoInput mt-2 mb-0">
                        {`Selecciona una o varias ${labelSubZonaTipo.toLowerCase()} donde prestarás este servicio.`}
                      </p>
                    </div>
                    //* DROPWON EN SUBZONA PARA UBICACION ENLOCAL *//
                    :<div className="form-floating"> 
                      <select
                        className="form-select"
                        value={formServicio?.subzonas[0] || ""}
                        onChange={(e) => {
                          setFormServicio((prev) => ({
                            ...prev,
                            coberturaCompletaCiudad: false,
                            subzona: e.target.value,
                            subzonas: e.target.value ? [e.target.value] : []
                          }));
                        }}
                      >
                        <option value="">Seleccione una subzona</option>
                        {subZonasDisponibles.map((subzona, idx) => (
                          <option key={subzona + idx} value={subzona}>{subzona}</option>
                        ))}
                      </select>
                      <label>{tipoDesplazamiento === "EnLocal" ? "Localidad" : labelSubZonaTipo}</label>
                      <p className="textoBajoInput">
                        {tipoDesplazamiento === "EnLocal"
                          ? "Selecciona la localidad donde está tu local."
                          : `Selecciona ${labelSubZonaTipo || "la subzona"} donde prestarás este servicio.`}
                      </p>
                    </div>
                    }
                  </div>
                ) : null}

                {/* DIRECCIÓN Y REFERENCIA */}
                {tipoServicio === "Presencial" && tipoDesplazamiento === "EnLocal" && (
                  <>
                    {/* Dirección */}
                    <div className="col-12 col-md-6">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          value={direccionTexto}
                          onChange={(e) => setDireccionTexto(e.target.value)}
                          placeholder="Dirección"
                        />
                        <label>Dirección</label>
                        <p className="textoBajoInput">
                          Ej: Calle 123 #45-67
                        </p>
                      </div>
                    </div>

                    {/* Referencia */}
                    <div className="col-12 col-md-6">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          value={referencia}
                          onChange={(e) => setReferencia(e.target.value)}
                          placeholder="Referencia"
                        />
                        <label>Referencia</label>
                        <p className="textoBajoInput">
                          Ej: Apto 301, casa azul, frente al parque
                        </p>
                      </div>
                    </div>
                  </>
                )}

                {/* MAPA */}
                {tipoServicio === "Presencial" && tipoDesplazamiento === "EnLocal" && (
                  <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
                      <label className="form-label fw-semibold mb-0">Selecciona la ubicación exacta en el mapa</label>

                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={obtenerUbicacionActual}
                      >
                        Obtener ubicación actual
                      </button>
                    </div>

                    <div className="alert alert-info mb-2">
                      📍 Haz clic en el mapa para marcar tu ubicación exacta o usa el botón para traer tu ubicación actual.
                    </div>

                    <MapaUbicacionServicio
                      latitud={latitud}
                      longitud={longitud}
                      onChange={(lat, lng) => {
                        setLatitud(lat);
                        setLongitud(lng);
                        setPrecisionUbicacion("exacta");
                      }}
                      ubicacionUsuario={ubicacionUsuario}
                    />

                    <p className="textoBajoInput mt-2">
                      Haz clic en el mapa para mover el pin a la ubicación exacta o usa el botón para tomar tu ubicación actual.
                    </p>
                  </div>
                )}


                {/* UBICACIÓN CAPTURADA */}
                {tipoServicio === "Presencial" && tipoDesplazamiento === "EnLocal" && latitud != null && longitud != null && (
                  <div className="col-12">
                    <div className="alert alert-light border mt-2 mb-0">
                      <i className="bi bi-geo-alt-fill me-2"></i>
                      <b>Ubicación capturada:</b> {latitud.toFixed(5)}, {longitud.toFixed(5)}
                    </div>
                  </div>
                )}
              </div>
            </>
          )}


          {/* NAVEGACIÓN */}
          <BotonesaPasos
            anterior={() => setPasoActual(1)}
            siguiente={() => setPasoActual(3)}
            onGuardar={(incluirPaquetes) => guardarProgreso({ mostrarAlerta: true, incluirPaquetes })}
            incluirPaquetesEnGuardar={false}
          />
        </form>
      </div>
    </div>
  );
}

export default Paso2;